<script>
import FullCalendar from '@fullcalendar/vue';
import CalendarEvent from "./event/calendar-event.vue";
import {combineEventsWithBackground, createCalendarOptions, parseToCalendarDate} from "./calendarUtils";
import {ThirdPartyDraggable} from "@fullcalendar/interaction";
import CalendarPrivileges from "./CalendarPrivileges";
import {CUSTOM_CONFIGURABLE_SETTINGS} from "./settings/calendarSettings";

export default {
    name: 'calendar',
    components: {
        CalendarEvent,
        FullCalendar
    },
    props: {
        events: {},
        activeEventId: String,
        privileges: CalendarPrivileges,
        disableSettings: Boolean,
        businessHours: Array
    },
    data: function() {
        return {
            draggable: undefined,
            dragging: false,
            disabledUntil: undefined,
        }
    },
    computed: {
        allSettings() {
            return createCalendarOptions(
                combineEventsWithBackground(this.events, this.disabledUntil, this.dragging),
                {
                    handleDrop: this.handleDrop,
                    handleEventChange: this.handleEventChange,
                    handleEventAllow: this.handleEventAllow
                },
                this.businessHours,
                this.disableSettings
            );
        },
        calendarSettings() {
            const filtered = {...this.allSettings};

            Object.keys(CUSTOM_CONFIGURABLE_SETTINGS).forEach(key => {
                delete filtered[key];
            });

            return filtered;
        }
    },
    methods: {
        handleDrop(info) {
            this.$emit('dropped', info);
        },
        handleEventChange(info) {
            this.$emit('changed', info);
        },
        handleEventAllow(dropInfo) {
            return dropInfo.start >= new Date();
        },
    },
    mounted() {
        const containerEl = document.querySelector('.dragdrop-content');

        this.draggable = new ThirdPartyDraggable(containerEl, {
            itemSelector: '.drag-drop-card',
            mirrorSelector: '.gu-mirror', // the dragging element that dragula renders
            eventData: function(eventEl) {
                return {
                    title: eventEl.innerText
                };
            }
        });

        EaseEventBus.listen('calendar-clickedSettings', () => {
            this.$emit('clickedSettings');
        });

        EaseEventBus.listen('calendar-goToDate', date => {
            if (this.$refs.fullCalendar) {
                const calendarApi = this.$refs.fullCalendar.getApi();
                calendarApi.gotoDate(date);
            }
        });

        // TODO refactor this to a solution without EventBus
        EaseEventBus.listen('dragging', isDragging => {
            this.dragging = isDragging;
        });
        EaseEventBus.listen('calendar-dragging', data => {
            const {validFrom} = data;
            if (validFrom) {
                this.disabledUntil = parseToCalendarDate(validFrom);
            } else {
                this.disabledUntil = undefined;
            }
        });
    },
    beforeDestroy() {
        this.draggable.destroy();
    }
}
</script>

<template>
    <FullCalendar ref="fullCalendar" :options='calendarSettings'>
        <template v-slot:eventContent='instance'>
            <calendar-event
                :instance="instance"
                :activeEventId="activeEventId"
                :privileges="privileges"
                :settings="allSettings"
                :calendarRef="$refs.fullCalendar"
                @click="(id, el) => $emit('clicked', id, el)"
                @clickAction="(action, el) => $emit('clickedAction', action, el)"
                @change="(element) => $emit('changed:menu', element)"
            />
        </template>
    </FullCalendar>
</template>

